import {
  ACCOUNT_TRANSACTIONS_SUCCESS,
  ACCOUNT_TRANSACTIONS_ERROR,
  UPDATE_ACCOUNT_TRANSACTION_STATUS,
  PORTFOLIO_TRANSACTIONS_SINGLE_ERROR,
  PORTFOLIO_TRANSACTIONS_SINGLE_SUCCESS,
  PORTFOLIO_FINANCIAL_PENDING_TRANSACTIONS_ERROR,
  PORTFOLIO_FINANCIAL_PENDING_TRANSACTIONS_SUCCESS,
  PATCH_PORTFOLIO_FINANCIAL_PENDING_TRANSACTIONS_ERROR,
} from '../../actions/portfolio/portfolioActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  data: [],
  error: '',
  singleTransaction: {
    data: {},
    error: '',
  },
  transactions: {
    data: {},
    error: '',
  },
  pendingTransactions: {
    data: {},
    error: '',
  },
  // Client-side status overrides keyed by transaction Uid (e.g. an SFH order
  // just cancelled). Re-applied on every account-transactions fetch so an
  // eventually-consistent backend refetch can't revert the cancelled status.
  optimisticTransactionStatuses: {},
};

// Force any loaded transaction whose Uid has an optimistic override onto that
// status, so refetches don't clobber a just-cancelled order.
function applyOptimisticStatuses(data, overrides) {
  const list = data?.Data;
  if (!Array.isArray(list) || !overrides || !Object.keys(overrides).length) {
    return data;
  }
  return {
    ...data,
    Data: list.map((transaction) =>
      Object.prototype.hasOwnProperty.call(overrides, transaction.Uid)
        ? { ...transaction, StatusType: overrides[transaction.Uid] }
        : transaction,
    ),
  };
}

export default createReducer(
  {
    [PORTFOLIO_TRANSACTIONS_SINGLE_SUCCESS]: setPortfolioSingleTransaction,
    [PORTFOLIO_TRANSACTIONS_SINGLE_ERROR]: setPortfolioSingleTransactionError,
    [ACCOUNT_TRANSACTIONS_SUCCESS]: setAccountTransactions,
    [ACCOUNT_TRANSACTIONS_ERROR]: setAccountTransactionsError,
    [UPDATE_ACCOUNT_TRANSACTION_STATUS]: updateAccountTransactionStatus,
    [PORTFOLIO_FINANCIAL_PENDING_TRANSACTIONS_ERROR]: setFinancialPendingTransactionsError,
    [PORTFOLIO_FINANCIAL_PENDING_TRANSACTIONS_SUCCESS]: setFinancialPendingTransactions,
    [PATCH_PORTFOLIO_FINANCIAL_PENDING_TRANSACTIONS_ERROR]: patchFinancialPendingTransactionsError,
  },
  initialState,
);

function setPortfolioSingleTransaction(state, action) {
  return {
    ...state,
    singleTransaction: {
      ...state.singleTransaction,
      data: action.payload,
    },
  };
}

function setPortfolioSingleTransactionError(state, action) {
  return {
    ...state,
    singleTransaction: {
      ...state.singleTransaction,
      error: action.payload,
    },
  };
}

function setAccountTransactions(state, action) {
  return {
    ...state,
    transactions: {
      data: applyOptimisticStatuses(
        action.payload,
        state.optimisticTransactionStatuses,
      ),
    },
  };
}

function setAccountTransactionsError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function updateAccountTransactionStatus(state, action) {
  const { transactionUid, statusType } = action.payload;
  const overrides = {
    ...state.optimisticTransactionStatuses,
    [transactionUid]: statusType,
  };

  return {
    ...state,
    optimisticTransactionStatuses: overrides,
    transactions: {
      ...state.transactions,
      data: applyOptimisticStatuses(state.transactions.data, overrides),
    },
  };
}

function setFinancialPendingTransactions(state, action) {
  return {
    ...state,
    pendingTransactions: {
      data: action.payload,
    },
  };
}

function setFinancialPendingTransactionsError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function patchFinancialPendingTransactionsError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}
